(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["designer-nav-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-scroll-to]');
    if (!card) return;

    var handle = card.getAttribute('data-scroll-to');
    if (!handle) return;

    var target = document.querySelector(
      '[data-designer-product-carousel][data-collection-handle="' + handle + '"]'
    );

    if (target) {
      e.preventDefault();
      var scrollTarget = target.closest('.shopify-section') || target;
      var stickyHeader = document.querySelector('sticky-header') || document.querySelector('.header-wrapper') || document.querySelector('header');
      var headerOffset = stickyHeader ? stickyHeader.offsetHeight + 20 : 20;
      var elementPosition = scrollTarget.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - headerOffset,
        behavior: 'smooth'
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
